import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { WhatsAppCta } from './WhatsAppCta';
import { WA_MESSAGES } from '@/lib/whatsapp';

export const PackageCard = ({ tier }) => {
  const [open, setOpen] = useState(false);
  const { cameras, resolution, storage, fit, benefit, night, ai } = tier.overview;
  return (
    <article id={tier.id} data-testid={`package-card-${tier.id}`} className={`gg-package ${tier.highlight ? 'gg-package-featured' : ''}`}>
      {tier.highlight && <p className="gg-package-ribbon" data-testid={`package-label-${tier.id}`}>PILIHAN POPULAR</p>}
      <div className="gg-package-body">
        <div className="gg-package-heading">
          <h3 data-testid={`package-name-${tier.id}`}>{tier.name}</h3>
          <p className="gg-package-price" data-testid={`package-price-${tier.id}`}>{tier.price.startsWith('Dari ') && <small>Dari </small>}{tier.price.replace('Dari ', '')}</p>
        </div>
        <p className="gg-package-fit" data-testid={`package-fit-${tier.id}`}>{fit}</p>
        <dl className="gg-package-facts" data-testid={`package-key-specs-${tier.id}`}>
          {[['Kamera', cameras], ['Resolusi', resolution], ['HDD', storage]].map(([label, value]) => <div key={label} data-testid={`package-${label.toLowerCase()}-${tier.id}`}><dt>{label}</dt><dd>{value}</dd></div>)}
        </dl>
        <p className="gg-package-benefit" data-testid={`package-benefit-${tier.id}`}>{benefit}</p>
        <Collapsible open={open} onOpenChange={setOpen} className="gg-package-details" data-testid={`package-details-${tier.id}`}>
          <div className="gg-package-actions">
            <CollapsibleTrigger asChild><button type="button" data-testid={`package-specs-toggle-${tier.id}`} data-track="package_specs_click" className="gg-package-toggle">{open ? 'Tutup butiran' : 'Butiran penuh'}<ChevronDown size={16} aria-hidden="true" /></button></CollapsibleTrigger>
            <WhatsAppCta testId={`pricing-whatsapp-cta-${tier.id}`} tier={tier} message={WA_MESSAGES.package(tier.name, tier.price)} className="gg-package-cta">WhatsApp {tier.name.replace('Guard ', '')}</WhatsAppCta>
          </div>
          <CollapsibleContent forceMount className="gg-specification-content" data-testid={`package-full-specs-${tier.id}`}>
            <dl className="gg-package-capabilities"><div><dt>Rakaman malam</dt><dd>{night}</dd></div><div><dt>Pengesanan & fungsi</dt><dd>{ai}</dd></div></dl>
            <p className="gg-specs-label">Kelengkapan pakej</p>
            <ul>{tier.features.map(feature => <li key={feature}>{feature}</li>)}</ul>
          </CollapsibleContent>
        </Collapsible>
      </div>
    </article>
  );
};